import { render } from "./Departments.vue?vue&type=template&id=27fc2dca&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"

import "./Departments.vue?vue&type=style&index=0&id=27fc2dca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fc2dca"]])

export default __exports__